import { render, staticRenderFns } from "./pcview.vue?vue&type=template&id=13c579cc&"
import script from "./pcview.vue?vue&type=script&lang=js&"
export * from "./pcview.vue?vue&type=script&lang=js&"
import style0 from "./pcview.vue?vue&type=style&index=0&id=13c579cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports